import React, { useEffect, useState } from 'react';
import { Crud_Catalogos } from '../herramientas/Crud_Catalogos';
import { timeToDatefull, milisecondsToHours, timeToTimeFull, timeToMilisegundos, diff, timeToDateFill } from "../herramientas/DateFormat";
import {TablePageable} from '../Helpers';
import Select from "react-select";
var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const ReporteTerrestre = ({ columnas }) => {
  const [remolques, setRemolques]= useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tipoMov, setTipoMov] = useState({ value: 0, label: "Todos"});
  const [estatus, setEstatus] = useState({ value: 3, label: "Finalizados"});
  const [fechaTipo, setFechaTipo] = useState({ value: "cita_programada", label: "Cita programada"});
  const [filters, setFilters] = useState({
    movimiento_tipo: '0',
    estatus: '[3]',
    fechaTipo: 'cita_programada',
    f1: timeToDateFill(new Date(new Date().setDate(new Date().getDate() - 30)).setHours(0, 0, 0, 0)),
    f2: timeToDateFill(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59, 59, 999))
  });
  
  useEffect(()=>{
    crud("get", "", "", "remolquesTipo", "remolquesTipo");
  }, []);

  const fetchReporte = () => {
    setLoading(true);
    try {
      const params = new URLSearchParams(filters);
      crud("get", "", "", `terrestreMovimientos/obtenerPorUsuarioParaClientes/${currentUser[0].usuario.id}`, "reporte");
    } catch (error) {
      console.error('Error fetching reporte:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    fetchReporte();
  };
  const crud=(metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
        switch (metodo) {
            case "get":
              if( stateVar === "reporte"){
                // El endpoint de terrestres devuelve un JSON string, necesitamos parsearlo
                const parsedData = typeof returnVal === 'string' ? JSON.parse(returnVal) : returnVal;
                setData(parsedData);
              }
              if( stateVar === "remolquesTipo"){
                let remolquesTemp= {};
                for(let r of returnVal){
                  remolquesTemp[r.idRemolque]= r;
                }
                setRemolques(remolquesTemp);
              }
            break;
            default:
                break;
        }
    }).catch(err => { console.log(err); });
  }
  const obtenerColumnas=()=>{
    let columnasTemp= [
      /*
        { 
          columna: "id",
          label: "Id",
          //enClick:(e) => setCurrentMovimiento(e), //enClickDisabled: (e)=> false,//e.idSolicitud === 303? false: true,
          //form: (e)=> <i className="fa fa-edit" style={{"font-size": "24px"}}><p style={{fontSize: "16px"}}>{e.idSolicitud}</p></i>
        },
        { columna: "idMovimiento", label: "idMovimiento" },
        { columna: "po", label: "Po", splitBy:";" },
      */
    ];
    // Filtrar para excluir "transporte"
    const columnasFiltradas = columnas.filter(c => c.columna !== "transporte");
    for(let c of columnasFiltradas){    
      switch (c.columna) {       
        case "contenedorTipo":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e[c.columna] === 1? "Seco": e[c.columna] === 2? "Refrigerado": "Caja" });
          break;
        case "contenedorSize":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e[c.columna] < 12?
                remolques[e[c.columna]]?
                  remolques[e[c.columna]].nombre
                  : e[c.columna]
                : e[c.columna],
            valor: (e)=> 
              e[c.columna] < 12?
                remolques[e[c.columna]]?
                  remolques[e[c.columna]].nombre
                  : e[c.columna]
                : e[c.columna]
          });
          break;
        case "estatus":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> <Form.Switch type="Checkbox" checked={e[c.columna]} /> });
          break;
        case "ontime":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( currentUser.filter(c=> c.plataforma.id === 1315 && e.idMovimientoTipo?.id === 2 ).length ){
                let tiempoTemp=//2023-10-05 16:41:00- 2023-10-05 13:35:00
                  e.inicioRutaVacio !== null
                  && e.arriboDirecionCarga !== null
                  && (new Date(e.inicioRutaVacio).getTime() - new Date(e.arriboDirecionCarga).getTime()) > 0 ?
                    new Date(e.inicioRutaVacio).getTime() - new Date(e.arriboDirecionCarga).getTime()
                  :0;
                //(date_part('epoch',(m.inicio_ruta_vacio - m.arribo_direcion_carga)) * interval '1 second')::text
                return  <div style={ tiempoTemp ? { "background-color": "green", } : {}}>
                          {timeToTimeFull(tiempoTemp)}
                        </div>
              }else{
                return  <div style={ timeToMilisegundos(e[c.columna]) ? { "background-color": "green", } : {}}>
                          {e[c.columna]}
                        </div>
              }
            }
          });
          break;
        case "delay":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( currentUser.filter(c=> c.plataforma.id === 1315 && e.idMovimientoTipo?.id === 2 ).length ){
                let tiempoTemp=
                  e.inicioRutaVacio !== null
                  && e.arriboDirecionCarga !== null
                  && (new Date(e.arriboDirecionCarga).getTime() - new Date(e.inicioRutaVacio).getTime()) > 0 ?
                    new Date(e.arriboDirecionCarga).getTime() - new Date(e.inicioRutaVacio).getTime()
                  :0;
                //(date_part('epoch',(m.arribo_direcion_carga - m.inicio_ruta_vacio)) * interval '1 second')::text
                return  <div style={ tiempoTemp ? { "background-color": "red", } : {}}>
                          {timeToTimeFull(tiempoTemp)}
                        </div>
              }else{
                return  <div style={ timeToMilisegundos(e[c.columna]) ? { "background-color": "red", } : {}}>
                          {e[c.columna]}
                        </div>
              }
            }
          });
          break;
        case "origen":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.idCorredor?.nombre || ""});
          break;
        case "fecha_asignacion":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.movimientosPatios[0]?.fechaCreacion});
          //TODO revisar si origen destino
          // columnasTemp.push({ columna: c.columna, label: c.label,
          //   form: (e)=> [1,3].includes(e[c.columna])? e.idCorredor.nombre: e.destino });
          break;
        case "destino":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.destino || ""});
          break;
        case "service failure":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> "" });
          break;
        case "full":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e.esFull ? "full" : "sencillo" });
          break;
        case "entrega vacio":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> {
              return e.idMovimientoTipo?.id === 1 && e.salidaClienteVacio && !e.arriboTerminalVacio2 ?
                diff(
                  new Date(
                    e.salidaClienteVacio
                  ).getTime(),
                  new Date().getTime()
                )
              : e.idMovimientoTipo?.id === 1 && e.salidaClienteVacio && e.arriboTerminalVacio2 ?
                diff(
                    new Date( //movimientos_terrestres_object: state.catalogos_reducer.movimientos_terrestres_object,
                      e.salidaClienteVacio
                    ).getTime(),
                    new Date(
                      e.arriboTerminalVacio2
                    ).getTime()
                  )
                : ""
            }});
          break;
        case "gps":
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            valor: (e)=> {
              let gpss= "";              
              if (e.movimientoGps && e.movimientoGps.length) {
                for( let gpsTem of e.movimientoGps ){
                    gpss= gpss + (gpss.length ? ", ":"") + gpsTem.gps.nombre;
                }
              }
              return gpss;
            },
            form: (e)=>{
              let gpss= "";              
              if (e.movimientoGps && e.movimientoGps.length) {
                for( let gpsTem of e.movimientoGps ){
                    gpss= gpss + (gpss.length ? ", ":"") + gpsTem.gps.nombre;
                }
              }
              return gpss;
            }});
          break;
        case "eta":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> {""}});
          break;
        case "citaProgramada":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo?.id === 1 || e.idMovimientoTipo?.id === 304) ){//ultima milla
                return e.citaProgramada;
              }else{
                if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo?.id === 2 || e.idMovimientoTipo?.id === 303) ){//ultima milla
                  return e.citaProgramada;
                }
                return e.citaProgramada
              }
            },
            valor: (e)=>{
              if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo?.id === 1 || e.idMovimientoTipo?.id === 304) ){//ultima milla
                return e.citaProgramada;
              }else{
                if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo?.id === 2 || e.idMovimientoTipo?.id === 303) ){//ultima milla
                  return e.citaProgramada;
                }
                return e.citaProgramada
              }
            }
          });
          break;
        case "citaProgramadaTerminal":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( c.idFuncionalidad === 2890 && (e.idMovimientoTipo?.id === 1 || e.idMovimientoTipo?.id === 304) ){//ultima milla
                return e.citaProgramadaTerminal;
              }else{
                if( c.idFuncionalidad === 2893 && (e.idMovimientoTipo?.id === 2 || e.idMovimientoTipo?.id === 303) ){//ultima milla
                  return e.citaProgramadaTerminal;
                }
                return 
              }
            },
            valor: (e)=>{
              if( c.idFuncionalidad === 2890 && (e.idMovimientoTipo?.id === 1 || e.idMovimientoTipo?.id === 304) ){//ultima milla
                return e.citaProgramadaTerminal;
              }else{
                if( c.idFuncionalidad === 2893 && (e.idMovimientoTipo?.id === 2 || e.idMovimientoTipo?.id === 303) ){//ultima milla
                  return e.citaProgramadaTerminal;
                }
                return 
              }
            }
          });
          break;
        case "consolidado_cita":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita : null,
          });
          break;
        case "desconsolidado_cita":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita : null,
          });
          break;
        case "contenedor_editar":
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=> e.contenedor,
            valor: (e)=> e.contenedor
          });
          break;
        case "sello_editar":
          columnasTemp.push({
            columna: c.columna,
            label: c.label,
            form: (e)=> e.sello,
            valor: (e)=> e.sello
          });
          break;
        case "onTimePickUp"://cita-fechaArribo
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( e.idMovimientoTipo?.id === 1 || e.idMovimientoTipo?.id === 304 ){//ultima milla
                //return milisecondsToHours( e.citaProgramada, e.arriboTerminalVacio)
                return milisecondsToHours( e.citaProgramadaTerminal, e.arriboTerminalVacio)
              }
              if( e.idMovimientoTipo?.id === 2 ){//primera milla
                return milisecondsToHours( e.citaProgramada, e.arriboDirecionCarga)
              }
              if( e.idMovimientoTipo?.id === 270 ){
                if (e.entregas.length != 0) {//consolidacion
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            },
            valor: (e)=>{
              if( e.idMovimientoTipo?.id === 1 || e.idMovimientoTipo?.id === 304 ){
                return milisecondsToHours( e.citaProgramada, e.arriboTerminalVacio)
              }
              if( e.idMovimientoTipo?.id === 2 ){
                return milisecondsToHours( e.citaProgramada, e.arriboDirecionCarga)
              }
              if( e.idMovimientoTipo?.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            }
          });
          break;
        case "onTimeDelivery"://importacin: citaProgramada-arriboCliente, distribución: e.cita-e.fechaArribo
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( e.idMovimientoTipo?.id === 1 ){
                return milisecondsToHours(e.citaProgramada, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo?.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo?.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            },
            valor: (e)=>{
              if( e.idMovimientoTipo?.id === 1 ){
                return milisecondsToHours(e.citaProgramada, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo?.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo?.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].cita,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            }
          });
          break;
        case "tiempoDescarga"://importacin: arriboClienteLleno-salidaClieneVacio, distribución: e.fechaArribo-fechaSalida
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( e.idMovimientoTipo?.id === 1 ){
                return milisecondsToHours(e.salidaClienteVacio, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo?.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo?.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            },
            valor: (e)=>{
              if( e.idMovimientoTipo?.id === 1 ){
                return milisecondsToHours(e.salidaClienteVacio, e.arriboClienteLleno)
              }
              if( e.idMovimientoTipo?.id === 2 ){
                return "S/I";
              }
              if( e.idMovimientoTipo?.id === 270 ){
                if (e.entregas.length != 0) {
                  return milisecondsToHours(
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida,
                    e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo
                  )
                }
                return "S/I";
              }
            }
          });
          break;
        case "consolidado_arribo":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo : null,
          });
          break;
        case "desconsolidado_arribo":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaArribo : null,
          });
          break;
        case "desconsolidado_salida":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>
              e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida : null,
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(b.cita).getTime() - new Date(a.cita).getTime())[0].fechaSalida : null
          });
          break;
        case "operador":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>  {
              return e.movimientosPatios?.length > 0  ? e.movimientosPatios?.[0]?.operadorNombre : ""
              
        } });
          
        break;
        case "transporte":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=> e['idTransportista']?.nombre
          }
            );
          break;
        case "otd":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if(timeToMilisegundos(e['ontime']) > 0){
                return "En tiempo"
              }
              if(timeToMilisegundos(e['delay']) > 0){
                return "Tarde"
              }
            },
            valor: (e)=> e.entregas.length === 2 ? e.entregas.sort((a, b) =>  new Date(a.cita).getTime() - new Date(b.cita).getTime())[0].fechaArribo : null,
          });
          break;
          case "registroOperador":
            columnasTemp.push({ columna: c.columna, label: c.label,
              form: (e)=> ""});
            break;
            case "remolquePlaca":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios?.length > 0 ? e.movimientosPatios?.[0]?.remolquePlaca: null
              });
            break;

            case "economicor":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios?.length > 0 ? e.movimientosPatios?.[0]?.economicor: null
              });
            break;

            case "operadorNombre":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios?.length > 0 ? e.movimientosPatios?.[0]?.operadorNombre: null
              });
            break;

            case "tractorPlaca":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios?.length > 0 ? e.movimientosPatios?.[0]?.tractorPlaca: null
              });
            break;

            case "operadorContacto":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>
                  e.movimientosPatios?.length > 0 ? e.movimientosPatios?.[0]?.operadorContacto: null
              });
            break;
        default: columnasTemp.push({ columna: c.columna, label: c.label });
          break;
      }
    }
    return columnasTemp;
  }
  return (
    <div>
      <h3>Reporte Terrestre</h3>
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="row">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Movimiento Tipo:</label>
              <Select
                placeholder="tipo"
                value={ tipoMov }
                onChange={ (e)=>{
                  setTipoMov(e);
                  setFilters({...filters, movimiento_tipo: e.value});
                }}
                options={[{ value: 0, label: "Todos"}]}
                isMulti={false}
              />
              {/* <input className="form-control" value={filters.movimiento_tipo} onChange={(e) => setFilters({...filters, movimiento_tipo: e.target.value})} /> */}
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Estatus:</label>
              <Select
                placeholder="tipo"
                value={ estatus }
                onChange={ (e)=>{
                  setEstatus(e);
                  let estatusTemp=[];
                  for(let est of e){
                    estatusTemp.push(est.value);
                    if(est.value === 1){
                      estatusTemp.push(2);
                    }
                  }
                  setFilters({...filters, estatus: '['+estatusTemp.toString()+']'});
                }}
                options={[{ value: 1, label: "Activos"},{ value: 3, label: "Finalizados"}]}
                isMulti={true}
              />
              {/*<input className="form-control" value={filters.estatus} onChange={(e) => setFilters({...filters, estatus: e.target.value})} />*/}
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Fecha Tipo:</label>
              <Select
                placeholder="tipo"
                value={ fechaTipo }
                onChange={ (e)=>{
                  setFechaTipo(e);
                  setFilters({...filters, fechaTipo: e.value});
                }}
                options={[{ value: "cita_programada", label: "Cita programada"},{ value: "creation_date", label: "Fecha de creación"}]}
                isMulti={false}
              />
              {/*<input className="form-control" value={filters.fechaTipo} onChange={(e) => setFilters({...filters, fechaTipo: e.target.value})} />*/}
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Fecha Inicio:</label>
              <input className="form-control" type="datetime-local" value={filters.f1.replace(' ', 'T')} onChange={(e) => setFilters({...filters, f1: e.target.value.replace('T', ' ')})} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Fecha Fin:</label>
              <input className="form-control" type="datetime-local" value={filters.f2.replace(' ', 'T')} onChange={(e) => setFilters({...filters, f2: e.target.value.replace('T', ' ')})} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <button type="submit" className="btn btn-primary">Generar Reporte</button>
            </div>
          </div>
        </div>
      </form>
      <hr/>
      <TablePageable
                titulo={
                  <div>Movimientos</div>
                }
                lista= { data }
                columnas={obtenerColumnas()}
                id= "id"
                selected={(e)=>{
                  //setAlarma(e);
                }}
                csvname= {"Movimientos"}
                /*
                csvname= "Reporte de evidencias "
                /*
                resaltarFuncion={(e)=>{
                  return incidencias.filter(i => i.incidencia.id === e.id  ).length ? true: false
                }}
                resaltarColor={(e)=>{
                  const etiquetaTemp= stor.etiquetas_object.filter(et => et.id === e.idEtiqueta);
                  if( etiquetaTemp.length !== 1){
                    return "rgba(242, 151, 151, 0.41)";
                  }
                  return "rgba(58, 223, 149, 0.25)";
                }}*/
                paginacion={true}
                elementosPorPagina={15}
              />
    </div>
  );
};

export default ReporteTerrestre;
